export enum ProductCategory {
    All = '',
    Rental = 'Rental',
    Sales = 'Sales',
    ServiceOrder = 'ServiceOrder',
}
